module.exports = __webpack_public_path__ + "exo-latin-500italic.1ac05bd5dc0714e32eac.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-500italic.svg
// module id = ../../../../typeface-exo/files/exo-latin-500italic.svg
// module chunks = styles